module.exports = __webpack_public_path__ + "static/media/iconGalleryActive.758e27e9.svg";